import apiService from './apiService';

/**
 * Service pour la gestion des documents
 */
class DocumentService {
  /**
   * Récupère la liste des documents avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order)
   */
  async getDocuments(params = {}) {
    const response = await apiService.get('/documents', params);
    return response.data;
  }

  /**
   * Récupère un document spécifique
   * @param {string} id - ID du document
   */
  async getDocument(id) {
    const response = await apiService.get(`/documents/${id}`);
    return response.data;
  }

  /**
   * Upload un nouveau document
   * @param {Object} documentData - Données du document (model_id, path, label, type_document_id)
   */
  async uploadDocument(documentData) {
    const formData = new FormData();
    
    if (documentData.path instanceof File) {
      formData.append('path', documentData.path);
    }
    if (documentData.model_id) {
      formData.append('model_id', documentData.model_id);
    }
    if (documentData.label) {
      formData.append('label', documentData.label);
    }
    if (documentData.type_document_id) {
      formData.append('type_document_id', documentData.type_document_id);
    }

    const response = await apiService.upload('/documents', formData);
    return response.data;
  }

  /**
   * Supprime un document
   * @param {string} id - ID du document
   */
  async deleteDocument(id) {
    return apiService.delete(`/documents/${id}`);
  }

  // === Type de documents ===

  /**
   * Récupère la liste des types de documents
   * @param {Object} params - Paramètres de recherche
   */
  async getTypeDocuments(params = {}) {
    const response = await apiService.get('/type-documents', params);
    return response.data;
  }

  /**
   * Récupère un type de document spécifique
   * @param {string} id - ID du type de document
   */
  async getTypeDocument(id) {
    const response = await apiService.get(`/type-documents/${id}`);
    return response.data;
  }

  /**
   * Crée un nouveau type de document
   * @param {Object} typeData - Données du type (label, code, description)
   */
  async createTypeDocument(typeData) {
    const response = await apiService.post('/type-documents', typeData);
    return response.data;
  }

  /**
   * Met à jour un type de document
   * @param {string} id - ID du type de document
   * @param {Object} typeData - Nouvelles données
   */
  async updateTypeDocument(id, typeData) {
    const response = await apiService.put(`/type-documents/${id}`, typeData);
    return response.data;
  }

  /**
   * Supprime un type de document
   * @param {string} id - ID du type de document
   */
  async deleteTypeDocument(id) {
    return apiService.delete(`/type-documents/${id}`);
  }
}

const documentServiceInstance = new DocumentService();
export default documentServiceInstance;
